import {
  IngestProject,
  IngestRemoteFile,
  IngestSubfolder,
} from '../../../../domain/src/lib/ingest/ingest-project.model';

/** Filas extra para que la tabla tenga varias páginas en vista prevía (p. ej. 22 ÷ 10 → página 0–2). */
const MOCK_INGEST_PROJECTS_EXTRA: IngestProject[] = Array.from(
  { length: 19 },
  (_, i) => {
    const id = i + 4;
    return {
      id,
      name: `VAULT_DEMO_${String(id).padStart(2, '0')}`,
      description: 'Proyecto demo para probar paginación (vista prevía)',
      folder_path: `DEMO_${id}`,
      is_active: true,
    };
  },
);

/** Datos solo para maquetación cuando `ingestUiMock` está activo en environment. */
export const MOCK_INGEST_PROJECTS: IngestProject[] = [
  {
    id: 1,
    name: 'DEFAULT',
    description: 'Ejemplo de proyecto (vista prevía)',
    folder_path: 'DEFAULT',
    is_active: true,
  },
  {
    id: 2,
    name: 'TRASFERENCIA_2022',
    description: 'Ejemplo de proyecto (vista prevía)',
    folder_path: 'TRASFERENCIA_2022',
    is_active: true,
  },
  {
    id: 3,
    name: 'ARCHIVO_CENTRAL',
    description: 'Ejemplo de proyecto (vista prevía)',
    folder_path: 'ARCHIVO_CENTRAL',
    is_active: true,
  },
  ...MOCK_INGEST_PROJECTS_EXTRA,
];

export function getMockProject(id: number): IngestProject | null {
  return MOCK_INGEST_PROJECTS.find((p) => p.id === id) ?? null;
}

/** Proyecto sintético para IDs creados solo en vista prevía (lista local). */
export function getPreviewProjectFallback(id: number): IngestProject {
  return {
    id,
    name: `Proyecto ${id}`,
    description: 'Vista prevía (creado en esta sesión)',
    folder_path: `PREVIEW_${id}`,
    is_active: true,
  };
}

/** Mock conocido o fallback para cualquier id válido en modo vista prevía. */
export function resolvePreviewProject(id: number): IngestProject | null {
  if (!Number.isFinite(id) || id < 1) return null;
  return getMockProject(id) ?? getPreviewProjectFallback(id);
}

export function getMockSubfolders(projectId: number): IngestSubfolder[] {
  const base: IngestSubfolder[] = [
    { path: '', display_name: '(Raíz)' },
    { path: '2024', display_name: '2024' },
    { path: '2024/Q1', display_name: '2024 → Q1' },
  ];
  if (projectId === 2) {
    return [
      { path: '', display_name: '(Raíz)' },
      { path: 'lotes', display_name: 'lotes' },
    ];
  }
  return base;
}

/** Archivos y carpetas de ejemplo para el explorador (vista prevía). */
export function getMockRemoteFiles(folderPath: string): IngestRemoteFile[] {
  const p = folderPath ?? '';
  if (p === '') {
    return [
      {
        name: 'contrato_demo.pdf',
        size: 245_812,
        is_folder: false,
        modified_at: new Date().toISOString(),
      },
      { name: '2024', size: 0, is_folder: true, modified_at: null },
      { name: 'Escaneos', size: 0, is_folder: true, modified_at: null },
    ];
  }
  if (p === '2024' || p.startsWith('2024/')) {
    return [
      {
        name: `escaneo_${p.replace(/\//g, '_')}.tif`,
        size: 1_024_000,
        is_folder: false,
        modified_at: null,
      },
    ];
  }
  if (p === 'lotes') {
    return [{ name: 'lote_001.zip', size: 4_200_000, is_folder: false, modified_at: null }];
  }
  if (p === 'Escaneos') {
    return [{ name: 'pagina_01.png', size: 890_000, is_folder: false, modified_at: null }];
  }
  return [];
}
